module.exports = __webpack_public_path__ + "img/google-play-badge.db9b21a1.png";